// alterado - revisado

import tipoReceitaMensalList from './tipoReceitaMensalList'

export const tipoReceitaMensalEntradaDadosList = ( idCorrente ) => {
    let tipoReceitaMensalEntradaDadosListAux = []

    tipoReceitaMensalList.forEach( (linhaTipoReceitaMensalList, index) => {
        if (
                linhaTipoReceitaMensalList.permiteEntradaDados === "S" ||
                (
                    idCorrente &&
                    linhaTipoReceitaMensalList.id === idCorrente
                )
        ) {
            tipoReceitaMensalEntradaDadosListAux.push(
                linhaTipoReceitaMensalList
            )
        }
    })

    return tipoReceitaMensalEntradaDadosListAux
}

export default tipoReceitaMensalEntradaDadosList